import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputNumber, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './productgroup-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import ProductChecklist from '../product/product-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ProductgroupCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadProductgroup = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'productgroup': data || [], 'productgroupCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }

    private onLoadProduct = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'product': data || [], 'productCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                }   
                <InputNumber name='seq' label='Sequence' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <InputPicklist name='productgroup' label='Sub Product Group List' value={this.state.datarow.productgroup} caption={this.state.datarow.productgroupCaption} disableAutoClose clearValue={this.onLoadProductgroup} error={this.state.errors?.productproductgroup} onChange={this.onChange}>
                    <ProductChecklist history={this.props.history} currentId={this.state.datarow.productgroup} onLoad={this.onLoadProductgroup} disableBackButton/>
                </InputPicklist> 
                <InputPicklist name='product' label='Product' value={this.state.datarow.product} caption={this.state.datarow.productCaption} disableAutoClose clearValue={this.onLoadProduct} error={this.state.errors?.product} onChange={this.onChange}>
                    <ProductChecklist history={this.props.history} currentId={this.state.datarow.product} onLoad={this.onLoadProduct} disableBackButton/>
                </InputPicklist> 

            </BaseCreate>
        );
    }     
     
}